import { FormattedMessage, useIntl } from "react-intl";
import Icon from "../../components/Icon/Icon";
import { pageSize, useBackofficeVideoFeedback } from "./useBackofficeVideoFeedback";
import styles from './BackofficeVideoFeedback.module.scss';
import { Feedback, TabStatus, User } from "./BackofficeVideoFeedback.model";
import Spinner from "../../components/Spinner/Spinner";
import { Pagination, Table, Tabs } from "antd";
import { useHistory } from "react-router";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import moment from "moment";


const BackofficeVideoFeedback = () => {
	const {
		getVideoFeedback,
		onChangeFeedbackPagination,
		state: {
			feedback,
			pagination,
			tabStatus
		}
	} = useBackofficeVideoFeedback();


	const intl = useIntl();

	const history = useHistory();

	const renderStars = (rating: number) => {
		const ratings = [1, 2, 3, 4, 5];
		return ratings.map(i => {
			if (i <= rating) return <span><Icon name="star" type="solid" color="orange" width="16px" height="16px" /></span>
			return <span><Icon name="star" type="light" color="orange" width="16px" height="16px" /></span>
		})
	}


	const columnsVideoFeedback = [
		{
			dataIndex: 'shortDescription',
			render: (shortDescription: string) => (<div className={styles.flexCell}>
				<div className={styles.starsWrapper}>{renderStars(parseInt(shortDescription))}</div>
			</div>),
			title: intl.formatMessage({ id: 'table.column.score' }),
		},
		{
			dataIndex: 'createdAt',
			render: (createdAt: string) => moment(createdAt).format("DD MMM YYYY"),
			title: intl.formatMessage({ id: 'table.column.date' }),
		},
		{
			dataIndex: 'createdBy',
			render: (createdBy: User) => (<span>{createdBy.firstName} {createdBy.lastName}</span>),
			title: intl.formatMessage({ id: 'table.column.sender' }),
		},
	];

	const onApplicationRow = (rowData: Feedback) => {
		return {
			onClick: () => {
				history.push(`/video-feedback/${rowData.id}`);
			},
		};
	}


	return <div className={styles.pageContainer}>
		<div className={styles.pageContent}>
			<Tabs>
				<Tabs.TabPane
					key="1"
					tab={<FormattedMessage id="navigation.videoFeedback" />}
					
				>
					<div className={styles.tabContent}>
						<Spinner spinning={tabStatus === TabStatus.Loading} />
						<ErrorMessage error={tabStatus === TabStatus.Error} onRefresh={getVideoFeedback} showReport={false}/>
						<div className={styles.table}>
							<Table
								columns={columnsVideoFeedback}
								dataSource={feedback}
								pagination={false}
								rowKey={(record) => record.id}
								onRow={onApplicationRow}
							/>
						</div>
						<div className={styles.contentMobile}>
							{feedback?.map((item) => {
								return (
									<div className={styles.card} onClick={() => history.push(`/video-feedback/${item.id}`)}>
										<div className={styles.cardContainer}>
											<div>
												<div className={styles.row}>
													<h2 className={styles.label}>
														<FormattedMessage id="table.column.score" />
													</h2>
													<div className={styles.flexCell}>
														<div className={styles.starsWrapper}>{renderStars(parseInt(item.shortDescription))}</div>
													</div>
												</div>
												<div>
													<h2>
														<FormattedMessage id="table.column.date" />
													</h2>
													<span>{moment(item.createdAt).format("DD MMM YYYY")}</span>
												</div>
												<div>
													<h2>
														<FormattedMessage id="table.column.sender" />
													</h2>
													<span>{item.createdBy.firstName} {item.createdBy.lastName}</span>
												</div>
											</div>
										</div>
									</div>
								);
							})}
						</div>
						<div className={styles.paginationWrapper}>
							<Pagination
								className={styles.pagination}
								current={pagination.page}
								pageSize={pageSize}
								total={pagination.total}
								onChange={onChangeFeedbackPagination}
								showSizeChanger={false}
							/>
						</div>
					</div>
				</Tabs.TabPane>

			</Tabs>
		</div>
	</div>

}
export default BackofficeVideoFeedback;